export const PhasedDrawdown = {
  PARTIAL: 'Partial',
  PHASED: 'Phased',
  REGULAR_UFPLS: 'Regular UFPLS',
  N_A: 'N/A'
};
